// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import { BootstrapVue, BootstrapVueIcons  } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vuex from 'vuex'
import axios from "axios"
import ImageUploader from "vue-image-upload-resize";
  
Vue.use(Vuex);
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(BootstrapVueIcons)
// ImageUploader (adaptación)
Vue.use(ImageUploader);

Vue.config.productionTip = false


const store = new Vuex.Store({
  state: {
    registros: [],
    registrosFiltrados: [],
    //urlBase:'http://localhost:5000', //comentar esta línea y descomentar la siguiente cuando se haga el build
    urlBase:''
  },
  mutations: {
    obtenerDatos(state){
      axios
      .get(`${state.urlBase}/datos`)
      .then(response => {
        console.log(response)
        state.registros = response.data.recordsets[0]
        //state.registrosFiltrados = response.data.recordsets[0]
      })
      .catch(err => {
        console.log(err)
      })
    },
    filtrar(state, filtros){
      var termino = filtros.terminoFiltro.trim().toUpperCase();
      var familia = filtros.familiaFiltro;
      console.log(termino);
      console.log(familia);

      if (termino.trim() == '' ){
        state.registrosFiltrados = state.registros;
      }

      if (termino.trim() != '' ){
        state.registrosFiltrados = state.registros.filter(
          function(registro){
            return (
              (registro.CODIGO).includes(termino) 
              || 
              (registro.DESCRIPCION).includes(termino)
              ||
              (registro.FAMILIA).includes(termino)
            )
          }
        )
      }
      
      if (familia != 'TODAS LAS FAMILIAS'){
        state.registrosFiltrados = state.registrosFiltrados.filter(
          function(registro){
            return registro.FAMILIA == familia
          }
        )
      }
    },
    subirImagen(state, file){
      
      var registros = state.registrosFiltrados.filter(
        function(registro){
          return registro.CODIGO == file.nombre;
        }
      )
      
      if (registros.length){
        registros[0].PHOTO = file.img;
      }
      
      axios.post('/archivo', file).then(function(respuesta) {
        console.log(respuesta);
      });

    }
  }
})



/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store: store
})
